// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__h8Ads","header":"MessagesList_header__N2-IH","chat":"MessagesList_chat__u0LqV"};